import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			marginTop: 'auto',
			marginBottom: 0,
			height: theme.spacing(7),
			minHeight: theme.spacing(7),
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			borderTop: `1px solid ${theme.palette.grey[200]}`,
		},
		activeContainer: {
			[theme.breakpoints.down('sm')]: {
				height: '100%',
				position: 'fixed',
				background: '#fff',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				zIndex: 100,
			},
		},
		inactiveContainer: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			flex: 1,
			alignSelf: 'stretch',
			cursor: 'pointer',
		},
		placeholder: {
			color: theme.palette.grey[300],
			fontSize: 16,
			fontWeight: 500,
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			[theme.breakpoints.down('sm')]: {
				overflow: 'auto',
			},
		},
		iconRoot: {
			marginRight: theme.spacing(1),
			[theme.breakpoints.down('sm')]: {
				marginRight: 0,
			},
		},
		manageTagsContainer: {
			flexShrink: 0,
		},
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			background: 'rgba(235, 235, 235, 0.7)',
			// pointerEvents: 'none',
			zIndex: 100,
		},
		iconButton: {
			padding: 10,
			color: theme.palette.grey[500],
		},
	})
